import { render } from "./IconTikTok.vue?vue&type=template&id=800c98aa"
import script from "./IconTikTok.vue?vue&type=script&lang=js"
export * from "./IconTikTok.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__